module.exports = __webpack_public_path__ + "static/media/ig.3597e496.png";